import React, { ReactElement, useRef } from 'react'

import {
   ApolloClient,
   ApolloClientOptions,
   ApolloProvider
} from '@apollo/client'

const AuthClientContext = React.createContext<ApolloClient<any> | null>(null)

export const ApolloClientWithAuthProvider = <TCacheShape,>(props: {
   config: ApolloClientOptions<TCacheShape>
   children: ReactElement
}) => {
   const { config, children } = props

   const authClientRef = useRef(new ApolloClient(config))

   return (
      <AuthClientContext.Provider value={authClientRef.current}>
         <ApolloProvider client={authClientRef.current}>
            {children}
         </ApolloProvider>
      </AuthClientContext.Provider>
   )
}

export const useApolloClientWithAuth = () => {
   const context = React.useContext(AuthClientContext)

   if (!context) {
      throw new Error('Expected to be wrapped in ApolloClientWithAuthnProvider')
   }

   return context
}
